import EmptyPlaceholder from "../../../../common/components/emptyPlaceholder/emptyPlaceholder";
import { Arrow } from "./arrow";
import styles from "../../dashboard.module.scss";

export const EmptyState = ({ isTeamView, emptyStateRef }) => {
  return (
    <div ref={emptyStateRef} className={styles.dashboardEmptyState}>
      <div className={styles.dashboardEmptyStateEmpty}>
        <EmptyPlaceholder
          description={
            isTeamView
              ? "Please select a client and recruiter to view metrics"
              : "Please select a client to view metrics"
          }
        />
      </div>
      <Arrow />
    </div>
  );
};
